import * as React from 'react';
import CircleCheckOutlined from './circle-check-outlined';
import CircleCheckFilled from './circle-check-filled';
import type { IconCombinedProps } from './types';
const CircleCheckCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <CircleCheckFilled ref={ref} {...rest} />;
  }
  return <CircleCheckOutlined ref={ref} {...rest} />;
});
export default CircleCheckCombined;